'use strict';
import React from 'react';
import { Router, Route, IndexRoute, applyRouterMiddleware, browserHistory } from 'react-router';
import { useScroll } from 'react-router-scroll';
import RouteConstants from '../constants/RouteConstants';
import App from '../components/App.jsx';
import Error from '../components/Error.jsx';
import ClientType from '../components/ClientType.jsx';
import ClientSearch from '../components/ClientSearch.jsx';
import ClientOin from '../components/ClientOin.jsx';
import ClientResults from '../components/ClientResults.jsx';
import ClientApplication from '../components/ClientApplication.jsx';
import ApplicationForm from '../components/ApplicationForm.jsx';
import NotFound from '../components/NotFound.jsx';
import Declaration from '../components/Declaration.jsx';
import ElectronicSubmission from '../components/ElectronicSubmission.jsx';
import Congratulations from '../components/Congratulations.jsx';
import NetCodeEntry from '../components/NetCodeEntry.jsx';
import ConfirmDetails from '../components/ConfirmDetails.jsx';
import IDVerification from '../components/IDVerification.jsx';
import AnnuitiesWelcomePage from '../components/AnnuitiesWelcomePage.jsx';
import ApplicationLoading from '../components/ApplicationLoading.jsx';
import HomeResolver from './HomeResolver';
import UrlService from '../services/UrlService';

function getHome() {
    window.NOA.adobe_mc = (new URL(window.location.href)).searchParams.get('adobe_mc');
    return HomeResolver.getHome(window.NOA);
}

function shouldUpdateScroll(prevRouterProps, nextRouterProps) {
    if(prevRouterProps && prevRouterProps.routes[1].path === RouteConstants.ConfirmDetails && 
    nextRouterProps.routes[1].path === RouteConstants.ApplicationForm) {
        return false;
    }
    return true;
}

let Routes = (
    <Router history={browserHistory} render={applyRouterMiddleware(useScroll(shouldUpdateScroll))}>
        <Route name="app" path={UrlService.getRoot()} component={App}>
            <IndexRoute  name="home" component={getHome()} />
            <Route path={RouteConstants.ClientSearch} component={ClientSearch} />
            <Route path={RouteConstants.ClientOin} component={ClientOin} />
            <Route path={RouteConstants.ClientResults} component={ClientResults} />
            <Route path={RouteConstants.ClientApplication} component={ClientApplication} />
            <Route path={RouteConstants.ApplicationForm} component={ApplicationForm} />
            <Route path={RouteConstants.ConfirmDetails} component={ConfirmDetails} />
            <Route path={RouteConstants.IDVerification} component={IDVerification} />
            <Route path={RouteConstants.AnnuitiesWelcomePage} component={AnnuitiesWelcomePage} />
            <Route path={RouteConstants.Declaration} component={Declaration} />
            <Route path={RouteConstants.ElectronicSubmission} component={ElectronicSubmission} />
            <Route path={RouteConstants.Congratulations} component={Congratulations} />
            <Route path={RouteConstants.NetCodeEntry} component={NetCodeEntry} />
            <Route path={RouteConstants.ApplicationLoading} component={ApplicationLoading} />                        
            <Route path={RouteConstants.ClientType} component={ClientType} />
            <Route path={RouteConstants.Error + '(/:action)(/:id)'} component={Error} />
            <Route path="*" component={NotFound} />
        </Route>
    </Router>
);

module.exports = Routes;



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./core/Routes.jsx